// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3048":"89a8d732","3068":"89a8d732","5531":"89a8d732","5585":"5aa45084"}[chunkId] + ".chunk.css";
};